import React, { useState } from 'react';
import { Box, Typography, Modal, IconButton } from '@mui/material';  

const EditHeading = ({
  hideOnMobile,
  isEditBtn = true,
  className,
  font16in14,
  myHeading,
}) => {
  

  return (
    <> 
   
    <Box className={className} sx={{ backgroundColor: '#FFFFFF', padding: {xs:'16px 16px', sm:'24px 20px'}, borderRadius: 2, my: {xs:'10px', sm:'20px'},display: {
          xs: hideOnMobile ? 'none' : 'block',
          md: 'block'
        } }}>
      {/* Header Row with Edit Button */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt:2 }}>
        <Typography
          className="FontIvypresto"
          fontWeight={600}
          sx={{
            fontSize: { xs: '20px', xl: '20px' },
            color: '#6A513E',
          }}
        >
          Heading
        </Typography> 
      </Box>

      {/* Static Text */}
      <Box className={font16in14} sx={{ mt: { xs: '4px', xl: '15px' } }}>
        <Typography
          sx={{
            fontSize: { xs: '12px', sm: '14px', xl: '16px' },
            color: '#3D3D3D',
            fontWeight: '400',
          }}
        >
            {myHeading}
        </Typography>
      </Box>
 </Box>
      
   </>
  );
};

export default EditHeading;
